module.exports = __webpack_public_path__ + "static/img/company-performance-barometer-hero.a33f166.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/company-performance-barometer-hero.jpg
// module id = 1T6/
// module chunks = 0